(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function cleanUrl() {
    return window.location.origin + window.location.pathname + window.location.search;
  }

  ready(function () {
    document.querySelectorAll('[data-moto-article]').forEach(function (page) {
      var body = page.querySelector('#moto-article-body');
      var toc = page.querySelector('[data-moto-toc]');
      var links = page.querySelector('[data-moto-toc-links]');
      var headings = body ? Array.from(body.querySelectorAll('h2')) : [];

      if (toc && links && headings.length > 1) {
        headings.forEach(function (heading, index) {
          if (!heading.id) heading.id = slugify(heading.textContent) || 'section-' + (index + 1);
          var link = document.createElement('a');
          link.href = '#' + heading.id;
          link.textContent = heading.textContent;
          // Scroll to the section without letting the browser push a #fragment
          // onto the address bar. A crawlable #fragment URL only exists if it
          // gets shared or linked externally, so keeping the hash out of the
          // URL bar here stops new fragment URLs from ever being copyable.
          link.addEventListener('click', function (event) {
            event.preventDefault();
            var target = document.getElementById(heading.id);
            if (target && target.scrollIntoView) {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });
          links.appendChild(link);
        });

        if ('IntersectionObserver' in window) {
          var tocLinks = Array.from(links.querySelectorAll('a'));
          var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              tocLinks.forEach(function (link) {
                link.toggleAttribute('aria-current', link.getAttribute('href') === '#' + entry.target.id);
              });
            });
          }, { rootMargin: '-18% 0px -68% 0px' });
          headings.forEach(function (heading) { observer.observe(heading); });
        }
      } else if (toc) {
        toc.hidden = true;
      }

      var share = page.querySelector('[data-moto-share]');
      var status = page.querySelector('[data-moto-share-status]');
      if (share) {
        share.addEventListener('click', function () {
          // Always share the clean canonical URL, never whatever fragment
          // happens to be in the address bar at click time.
          var payload = { title: document.title, url: cleanUrl() };
          if (navigator.share) {
            navigator.share(payload).catch(function () {});
            return;
          }
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(cleanUrl()).then(function () {
              share.textContent = 'Link copied';
              if (status) status.textContent = 'Article link copied to clipboard.';
              window.setTimeout(function () {
                share.textContent = 'Share article';
                if (status) status.textContent = '';
              }, 2200);
            });
          }
        });
      }
    });
  });
})();
